import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileUpdateMetadataMutationAtom = createMutationAtomFactory(
  'files.updateMetadata',
  ({
    fileId,
    metadata,
  }: {
    fileId: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metadata: Record<string, any>;
  }) => ({
    filesUpdateFileMetadata: {
      __args: {
        fileID: fileId,
        input: {
          metadata,
        },
      },
      id: true,
      fileName: true,
      metadata: true,
    },
  }),
);
